const cardItems = [
  {
    title: '偶像练习生2026',
    desc: '本季最火选秀综艺，偶像练习生最新舞台纯享，高清全集在线观看',
    tag: '热播中',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20a%20talent%20show%20competition%20stage%20with%20young%20performers%20under%20warm%20golden%20spotlights%2C%20minimalist%20design%20with%20coral%20and%20amber%20color%20palette%2C%20clean%20geometric%20shapes%2C%20entertainment%20theme%2C%20soft%20glowing%20atmosphere&width=800&height=500&seq=card-01&orientation=landscape',
  },
  {
    title: '极限挑战王',
    desc: '偶像团体户外生存挑战，真人秀巅峰之作，紧张刺激全程高能',
    tag: '热门',
    img: 'https://readdy.ai/api/search-image?query=Flat%20design%20illustration%20of%20outdoor%20adventure%20challenge%20with%20abstract%20mountain%20and%20forest%20scenery%2C%20warm%20sunset%20golden%20tones%2C%20minimalist%20style%2C%20silhouettes%20of%20people%20on%20an%20adventure%2C%20coral%20accents%2C%20clean%20composition&width=800&height=500&seq=card-02&orientation=landscape',
  },
  {
    title: '爱豆音乐舞台',
    desc: '偶像团体最新打歌舞台合集，沉浸式音乐视听盛宴',
    tag: '精选',
    img: 'https://readdy.ai/api/search-image?query=Minimalist%20flat%20illustration%20of%20music%20concert%20stage%20with%20colorful%20abstract%20light%20beams%20in%20warm%20coral%20and%20golden%20gradients%2C%20clean%20theatrical%20atmosphere%2C%20modern%20entertainment%20design%2C%20soft%20glow%20effects&width=800&height=500&seq=card-03&orientation=landscape',
  },
  {
    title: '甜蜜心动观察',
    desc: '偶像恋爱观察真人秀，甜蜜互动全程记录，心动瞬间不容错过',
    tag: '新番',
    img: 'https://readdy.ai/api/search-image?query=Artistic%20flat%20illustration%20of%20romantic%20dating%20reality%20show%20scene%20with%20soft%20warm%20lighting%2C%20minimalist%20geometric%20style%2C%20peach%20and%20rose%20color%20palette%2C%20clean%20composition%2C%20gentle%20atmosphere%2C%20abstract%20heart%20shapes&width=800&height=500&seq=card-04&orientation=landscape',
  },
  {
    title: '旅行综艺全记录',
    desc: '跟随偶像环游世界，治愈系旅行综艺，每一帧都是壁纸级画面',
    tag: '治愈',
    img: 'https://readdy.ai/api/search-image?query=Flat%20design%20illustration%20of%20travel%20adventure%20with%20abstract%20world%20landmarks%2C%20warm%20golden%20hour%20lighting%20over%20minimalist%20landscape%2C%20coral%20and%20amber%20gradients%2C%20clean%20geometric%20style%2C%20peaceful%20exploration%20theme&width=800&height=500&seq=card-05&orientation=landscape',
  },
  {
    title: '喜剧搞笑合集',
    desc: '爆笑综艺片段精选合集，偶像团体搞笑日常，轻松一刻欢乐无限',
    tag: '爆笑',
    img: 'https://readdy.ai/api/search-image?query=Colorful%20flat%20illustration%20of%20comedy%20variety%20show%20atmosphere%20with%20abstract%20laughing%20faces%20and%20fun%20elements%2C%20warm%20coral%20and%20yellow%20tones%2C%20minimalist%20style%2C%20playful%20geometric%20shapes%2C%20bright%20cheerful%20composition&width=800&height=500&seq=card-06&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-3">
          热门推荐
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          爱豆影视精选热门综艺推荐，高清流畅不卡顿
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardItems.map((item, i) => (
            <div
              key={i}
              className="group bg-background-100 rounded-lg border border-background-200/70 overflow-hidden cursor-pointer hover:border-primary-200 transition-all flex flex-col"
            >
              <div className="relative w-full aspect-[8/5] overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={`爱豆影视 - ${item.title}`}
                  title={`爱豆影视${item.title}高清免费在线观看`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-primary-500 text-background-50 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="text-base font-semibold text-foreground-800 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed flex-1">{item.desc}</p>
                <div className="flex items-center justify-between mt-4 pt-4 border-t border-background-200/70">
                  <span className="text-xs text-foreground-400">高清免费在线观看</span>
                  <span className="flex items-center gap-1 text-xs text-primary-600 font-medium whitespace-nowrap">
                    立即观看 <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}